import React from 'react';
import { InfoWindow } from 'react-google-maps';
import styles from './Dispatcher.css';

const EventListInfoWindow = ({
  events,
  onEventClick,
  onPreviewEvent,
  ...props
}) => (
  <InfoWindow {...props}>
    <div>
      {events.map(e => (
        <h5
          className={styles.eventsListWindowEvent}
          key={e.id}
          onDoubleClick={() => onEventClick(e)}
          onMouseOver={() => onPreviewEvent(e)}
          onMouseOut={() => onPreviewEvent(null)}
        >
          {e.purchaseOrder && `${e.purchaseOrder.poNumber} - ${e.purchaseOrder.name}`}
          {e.job && `${e.job.jobNumber} - ${e.job.name}`}
        </h5>
      ))}
    </div>
  </InfoWindow>
);

export default EventListInfoWindow;
